import script from "./BaseCheckboxOtherInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCheckboxOtherInput.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCheckboxOtherInput.vue?vue&type=style&index=0&id=34a2f9e7&lang=scss"

const __exports__ = script;

export default __exports__